import AWS from 'aws-sdk';

const spacesEndpoint = new AWS.Endpoint(process.env.REACT_APP_DIGITALOCEAN_SPACE_ENDPOINT);
const s3 = new AWS.S3({
    endpoint: spacesEndpoint,
    accessKeyId: process.env.REACT_APP_DIGITALOCEAN_SPACE_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_DIGITALOCEAN_SPACE_ACCESS_SECRET_KEY
});

export default s3;